// @flow
import { QRConfActionTypes } from './constants';

const INIT_STATE = {
    QRCode: null,
    configuration: {},
    loading: false,
    error: false,
    formSubmited: false,
    loadingConf: false,
    errorConf: false,
    formSubmitedConf: false
};

type QRConfAction = {
    type: string,
    payload: { actionType?: string, data?: any, error?: string },
};
type State = { QRCode?: null, loading?: boolean, +value ?: boolean };

const QRConf = (state: State = INIT_STATE, action: QRConfAction): any => {
    // console.log(action);
    switch (action.type) {
        case QRConfActionTypes.API_RESPONSE_SUCCESS:
            switch (action.payload.actionType) {
                case QRConfActionTypes.UPDATE_QR_CONF: {
                    return {
                        ...state,
                        configuration: action.payload.data,
                        errorConf: false,
                        loadingConf: false,
                        formSubmitedConf: true
                    };
                }
                case QRConfActionTypes.GENERATE_QR: {
                    return {
                        ...state,
                        QRCode: action.payload.data,
                        error: false,
                        loading: false,
                        formSubmited: true
                    };
                }
                default:
                    return { ...state };
            }

        case QRConfActionTypes.API_RESPONSE_ERROR:
            switch (action.payload.actionType) {
                case QRConfActionTypes.UPDATE_QR_CONF: {
                    return {
                        ...state,
                        configuration: {},
                        errorConf: action.payload.error,
                        loadingConf: false,
                        formSubmitedConf: true
                    };
                }
                case QRConfActionTypes.GENERATE_QR: {
                    return {
                        ...state,
                        QRCode: null,
                        error: action.payload.error,
                        loading: false,
                        formSubmited: true
                    };
                }
                default:
                    return { ...state };
            }

        case QRConfActionTypes.UPDATE_QR_CONF:
            return { ...state, errorConf: false, loadingConf: true };
        case QRConfActionTypes.GENERATE_QR:
            return { ...state, error: false, loading: true };
        case QRConfActionTypes.RESET:
            return {
                ...state,
                loading: false,
                error: false,
                configuration: {},
                QRCode: null,
                formSubmited: false,
                loadingConf: false,
                errorConf: false,
                formSubmitedConf: false
            };
        default:
            return { ...state };
    }
};

export default QRConf;
